import { Dispatch } from "redux";
import {
  getPages,
  createPage,
  updatePage,
  deletePage,
  getPageByPojectId,
} from "../../services/PageService";
import { Page } from "../../types/Page";

export enum PageActionType {
  FETCH_PAGES = "FETCH_PAGES",
  ADD_PAGE = "ADD_PAGE",
  EDIT_PAGE = "EDIT_PAGE",
  DELETE_PAGE = "DELETE_PAGE",
  FETCH_PAGES_PROJECTID = "FETCH_PAGES_PROJECTID",
}

export interface FetchPages {
  type: PageActionType.FETCH_PAGES;
  data: Page[];
}

export interface AddPage {
  type: PageActionType.ADD_PAGE;
  data: Page;
}

export interface EditPage {
  type: PageActionType.EDIT_PAGE;
  data: Page;
}

export interface DeletePage {
  type: PageActionType.DELETE_PAGE;
  data: number;
}

export interface FetchPagesProjecId {
  type: PageActionType.FETCH_PAGES_PROJECTID;
  data: Page[];
}

export type PageAction =
  | FetchPages
  | AddPage
  | EditPage
  | DeletePage
  | FetchPagesProjecId;
export const fetchPages = () => async (dispatch: Dispatch) => {
  const data = await getPages();
  dispatch<FetchPages>({ type: PageActionType.FETCH_PAGES, data });
};

export const addPage = (mod: Page) => async (dispatch: Dispatch) => {
  const response = await createPage(mod);
  dispatch<AddPage>({
    type: PageActionType.ADD_PAGE,
    data: response.data.data,
  });
};

export const editPage =
  (id: number, mod: Page) => async (dispatch: Dispatch) => {
    const response = await updatePage(id, mod);
    dispatch<EditPage>({
      type: PageActionType.EDIT_PAGE,
      data: response.data.data,
    });
  };

export const deletePageById = (id: number) => async (dispatch: Dispatch) => {
  await deletePage(id);
  dispatch<DeletePage>({ type: PageActionType.DELETE_PAGE, data: id });
};
export const fetchPagesByProject =
  (projectId: number) => async (dispatch: Dispatch) => {
    try {
      const response = await getPageByPojectId(projectId);

      dispatch<FetchPagesProjecId>({
        type: PageActionType.FETCH_PAGES_PROJECTID,
        data: response.data.data,
      });
    } catch (error) {
      console.error("Error fetching filtered Pages", error);
    }
  };
